"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchComponent = void 0;
const fetch_1 = __importDefault(require("./fetch"));
class FetchComponent {
    constructor() {
        this.installed = false;
    }
    /**
     * Vue.js component install method
     */
    install(app) {
        if (this.installed) {
            return;
        }
        this.installed = true;
        app.provide('fetch', fetch_1.default);
    }
}
exports.FetchComponent = FetchComponent;
exports.default = new FetchComponent();
